import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	useOtherDates: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.configured-dates-flag.use-other-dates',
		defaultMessage: 'Use other dates',
		description: 'Button on flag to go to settings page',
	},
	keepUsingTargetDates: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.configured-dates-flag.keep-using-target-dates',
		defaultMessage: 'Keep using default dates',
		description: 'Button on flag to use default dates',
	},
});
